<script setup>
const props=defineProps({categorySlug:String,options:{type:Object,required:true}});const route=useRoute();
const query=computed(()=>({q:props.options.search,page:props.options.page,limit:48,categorySlug:props.categorySlug,sort:props.options.sort,filters:JSON.stringify(props.options.filters)}));
const {data,error,pending,refresh}=await useFetch('/api/catalog/search',{key:'catalog-ranked-search-'+(props.categorySlug||'all'),query});
const page=computed(()=>props.options.page);
function routeError(){const status=Number(error.value?.statusCode||error.value?.status);if(status===404||status===400){const failure=createError({statusCode:status,message:status===404?'Страница результатов не найдена.':'Некорректные параметры поиска.'});if(import.meta.server)throw failure;showError(failure);}}
routeError();watch(error,routeError);
</script>
<template>
 <section aria-label="Результаты поиска" :aria-busy="pending">
  <p v-if="error" role="alert">Поиск временно недоступен. <button type="button" class="uo-btn uo-btn-secondary" @click="refresh">Повторить</button></p>
  <template v-else>
   <p role="status">Найдено растений: {{data?.total||0}}</p>
   <CatalogSeedsList :seeds="data?.items||[]" />
   <CommonPagination v-if="data?.total>48" :current="page" :total="data.total/48" />
  </template>
 </section>
</template>
